import { axiosClient } from '@lib/axiosClient';

import type { Profile, ProfileUpdate } from './profile.types';

const PROFILE_SUPPORT_PATH = '/api/smartpass-profile/v1/profile/support';

function defaultHeaders(accessToken: string) {
  return { Authorization: `Bearer ${accessToken}`, 'service-name': 'smartpass-perfil-cidadao-web' };
}

export async function getProfile(cpf: string, accessToken: string): Promise<Profile> {
  const { data } = await axiosClient.get<Profile>(`${PROFILE_SUPPORT_PATH}/${encodeURIComponent(cpf)}`, {
    headers: defaultHeaders(accessToken),
  });

  console.log(data);

  return data;
}

export async function updateProfile(cpf: string, payload: ProfileUpdate, accessToken: string): Promise<Profile> {
  const { data } = await axiosClient.patch<Profile>(`${PROFILE_SUPPORT_PATH}/${encodeURIComponent(cpf)}`, payload, {
    headers: defaultHeaders(accessToken),
  });

  return data;
}
